document.addEventListener("DOMContentLoaded", () => {
  console.log("0 refresh");
  // Initial run
  initMeetDropdown();
  initHeaderShrink();
  initMegaDropdowns();
  initMobileNav();
  initFooterAccordion();

  // Retry after 2 seconds
  setTimeout(() => {
  console.log("2s refresh");
    initMeetDropdown();
    initMegaDropdowns();
    initMobileNav();
    initFooterAccordion();
  }, 2000);

  // Optional: periodic safety recheck for 10 seconds
  let recheckCount = 0;
  const recheckInterval = setInterval(() => {
  console.log("10s refresh");
    initMeetDropdown();
    initMegaDropdowns();
    initMobileNav();
    initFooterAccordion();

    if (++recheckCount > 5) clearInterval(recheckInterval);
  }, 2000);

  let lastWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    const nav = document.querySelector(".mobile-nav-wrapper");
    const width = window.innerWidth;

    // Trigger only when crossing the 1200px breakpoint
    const crossedBreakpoint =
      (lastWidth <= 1200 && width > 1200) || (lastWidth > 1200 && width <= 1200);

    if (crossedBreakpoint && nav) {
      nav.classList.add("no-transition");
      nav.classList.remove("open"); // instantly hide

      // Remove after 300ms to re-enable transitions
      setTimeout(() => nav.classList.remove("no-transition"), 300);
    }

    lastWidth = width;
  });
});

function initMeetDropdown(){
  const meetBtn = document.querySelector(".meet-btn");

  if (meetBtn) {
    const dropdown = meetBtn.nextElementSibling; // next sibling
    const dropdownClose = dropdown?.querySelector(".meet-dropdown-close");

    let clickOpen = false;

    const removeHoverListeners = () => {
      meetBtn.onmouseenter = null;
      meetBtn.onmouseleave = null;
      if (dropdown) {
        dropdown.onmouseenter = null;
        dropdown.onmouseleave = null;
      }
    };

    const enableHover = () => {
      let hoverTimeout;

      const addActive = () => {
        clearTimeout(hoverTimeout);
        meetBtn.classList.add("active");
        dropdown?.classList.add("active");
      };

      const removeActive = () => {
        hoverTimeout = setTimeout(() => {
          meetBtn.classList.remove("active");
          dropdown?.classList.remove("active");
        }, 50);
      };

      meetBtn.addEventListener("mouseenter", addActive);
      meetBtn.addEventListener("mouseleave", removeActive);
      if (dropdown) {
        dropdown.addEventListener("mouseenter", addActive);
        dropdown.addEventListener("mouseleave", removeActive);
      }

      // Disable click on desktop
      meetBtn.onclick = null;
    };

    const enableClick = () => {
      meetBtn.onclick = function (e) {
        e.preventDefault();
        clickOpen = !clickOpen;
        meetBtn.classList.toggle("active", clickOpen);
        dropdown?.classList.toggle("active", clickOpen);
      };
    };

    const setBehavior = () => {
      removeHoverListeners();
      clickOpen = false;
      meetBtn.classList.remove("active");
      dropdown?.classList.remove("active");

      if (window.innerWidth >= 1200) {
        enableHover();
      } else {
        enableClick();
      }
    };

    setBehavior();

    window.addEventListener("resize", setBehavior);

    // Close when clicking the close button inside dropdown
    if (dropdownClose) {
      dropdownClose.addEventListener("click", function () {
        clickOpen = false;
        meetBtn.classList.remove("active");
        dropdown?.classList.remove("active");
      });
    }

    // Close when clicking outside
    document.addEventListener("click", function (e) {
      if (
        !meetBtn.contains(e.target) &&
        !dropdown?.contains(e.target)
      ) {
        clickOpen = false;
        meetBtn.classList.remove("active");
        dropdown?.classList.remove("active");
      }
    });
  }
}

function initHeaderShrink(){
  const header = document.querySelector(".custom-header");

  function checkScroll() {
    if (window.scrollY > 100) {
      header.classList.add("shrinked");
    } else {
      header.classList.remove("shrinked");
    }
  }

  // Run on page load
  checkScroll();

  // Run on scroll
  window.addEventListener("scroll", checkScroll);
}


function initMegaDropdowns(){
  const dropdowns = document.querySelectorAll('.mega-dropdown-container');

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.mdc-btn');
    const menu = dropdown.querySelector('.nav-dropdown-container');

    let clickOpen = false;

    // Remove all hover listeners (desktop)
    const removeHoverListeners = () => {
      trigger.onmouseenter = null;
      trigger.onmouseleave = null;
      if (menu) {
        menu.onmouseenter = null;
        menu.onmouseleave = null;
      }
    };

    // Desktop hover behavior
    const enableHover = () => {
      let hoverTimeout;

      const addActive = () => {
        clearTimeout(hoverTimeout);
        dropdown.classList.add('active');
      };

      const removeActive = () => {
        hoverTimeout = setTimeout(() => {
          dropdown.classList.remove('active');
        }, 50);
      };

      trigger.addEventListener('mouseenter', addActive);
      trigger.addEventListener('mouseleave', removeActive);
      if (menu) {
        menu.addEventListener('mouseenter', addActive);
        menu.addEventListener('mouseleave', removeActive);
      }
    };

    // Mobile click behavior
    const enableClick = () => {
      trigger.onclick = (e) => {
        e.preventDefault();
        clickOpen = !clickOpen;
        dropdown.classList.toggle('active', clickOpen);
      };

      // Close if clicked outside
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          clickOpen = false;
          dropdown.classList.remove('active');
        }
      });
    };

    const setDropdownBehavior = () => {
      removeHoverListeners();
      if (window.innerWidth >= 1200) {
        enableHover();
        trigger.onclick = null; // disable click on desktop
      } else {
        enableClick();
      }
    };

    setDropdownBehavior();

    window.addEventListener('resize', () => {
      clickOpen = false;
      dropdown.classList.remove('active');
      setDropdownBehavior();
    });
  });
}


function initMobileNav(){
  const menuBtn = document.querySelector(".menu-btn");
  const mobileNav = document.querySelector(".mobile-nav-wrapper");
  const headerContent = mobileNav.querySelector(".header-content");
  const navCloser = headerContent.querySelector(".nav-closer");

  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  const openMenu = () => {
    document.body.style.overflow = "hidden";
    mobileNav.classList.add("open");
    headerContent.style.transform = "translateY(0)"; // slide up
  };

  const closeMenu = () => {
    document.body.style.overflow = "auto";
    headerContent.style.transform = "translateY(100%)"; // slide down
    setTimeout(() => {
      mobileNav.classList.remove("open");
    }, 300); // wait for slide down animation
  };

  // Click menu button to open
  menuBtn.addEventListener("click", (e) => {
    e.preventDefault();
    openMenu();
  });

  // Click backdrop to close
  mobileNav.addEventListener("click", (e) => {
    if (e.target === mobileNav) closeMenu();
  });

  // Drag to close
  navCloser.addEventListener("touchstart", (e) => {
    isDragging = true;
    startY = e.touches[0].clientY;
  });

  navCloser.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    currentY = e.touches[0].clientY;
    const diff = currentY - startY;
    if (diff > 0) {
      headerContent.style.transform = `translateY(${diff}px)`;
    }
  });

  navCloser.addEventListener("touchend", () => {
    isDragging = false;
    const diff = currentY - startY;
    if (diff > 100) {
      // if dragged more than 100px, close
      closeMenu();
    } else {
      // reset
      headerContent.style.transform = "translateY(0)";
    }
  });
}

function initFooterAccordion(){
    const columns = document.querySelectorAll(".custom-footer__column");

    columns.forEach(column => {
      const heading = column.querySelector(".custom-footer__column-heading");
      const links = column.querySelector(".custom-footer__links");

      if (heading && links) {
        heading.addEventListener("click", () => {
          const isActive = column.classList.contains("active");

          // Close all other columns
          columns.forEach(col => {
            col.classList.remove("active");
            const colLinks = col.querySelector(".custom-footer__links");
            if (colLinks) colLinks.style.maxHeight = null;
          });

          // If it wasn’t active, open it
          if (!isActive) {
            column.classList.add("active");
            links.style.maxHeight = links.scrollHeight + "px";
          }
        });
      }
    });

}

  console.log("00 refresh");
  // Initial run
  initMeetDropdown();
  initHeaderShrink();
  initMegaDropdowns();
  initMobileNav();
  initFooterAccordion();
